import { Component, Event, EventEmitter, getAssetPath, h, Host, Prop } from '@stencil/core';

import wcShared from '@web-components/shared';

import newsStore, { TabsType } from '../../stores/news.store';

@Component({
  tag: 'news-component',
  styleUrl: 'news.scss',
  shadow: true,
})
export class News {
  @Event() handleNewsEvent: EventEmitter<{ unseenNewsCount: number; toClose: boolean }>;

  @Prop() readonly isVisible: boolean;

  render() {
    if (this.isVisible)
      return (
        <Host>
          <div class="news">
            <div class="news__header">
              <div class="title">
                <span class="bg-icon">
                  <img
                    src={getAssetPath('./../assets/icons/k-icon.svg')}
                    alt="infomaniak-icon"
                  />
                </span>
                News
                {newsStore.unseenNewsCount > 0 && (
                  <span class="unseen-count">{newsStore.unseenNewsCount}</span>
                )}
              </div>

              <svg
                role="button"
                width="17"
                height="16"
                viewBox="0 0 17 16"
                xmlns="http://www.w3.org/2000/svg"
                class="cross-icon"
                fill="currentColor"
                onClick={() =>
                  this.handleNewsEvent.emit({
                    unseenNewsCount: newsStore.unseenNewsCount,
                    toClose: true,
                  })
                }
              >
                <path d="M16.8535 0.852577C17.0492 0.657315 17.0492 0.340732 16.8535 0.14547C16.6578 -0.0497921 16.3405 -0.0497921 16.1448 0.14547L8.98254 7.29192L1.82028 0.14547C1.62459 -0.0497921 1.30731 -0.0497921 1.11161 0.14547C0.91592 0.340732 0.91592 0.657315 1.11161 0.852577L8.27386 7.99902L1.11161 15.1455C0.91592 15.3407 0.91592 15.6573 1.11161 15.8526C1.30731 16.0478 1.62459 16.0478 1.82028 15.8526L8.98254 8.70613L16.1448 15.8526C16.3405 16.0478 16.6578 16.0478 16.8535 15.8526C17.0492 15.6573 17.0492 15.3407 16.8535 15.1455L9.69121 7.99902L16.8535 0.852577Z" />
              </svg>
            </div>

            {newsStore.currentEventCount > 0 && (
              <div class="news__events">
                <div class="events-wrapper">
                  <div class="events-content">
                    <img
                      src={getAssetPath('./../assets/icons/incidents.svg')}
                      alt="incidents-icon"
                    />
                    {wcShared?.translate('$nb$ evenements en cours', {
                      nb: newsStore.currentEventCount,
                    })}
                  </div>
                  <a
                    href="https://infomaniakstatus.com"
                    target="_blank"
                    rel="noopener, noreferrer"
                  >
                    {wcShared?.translate('Details')}
                  </a>
                </div>
              </div>
            )}

            <div class="news__tabs">
              {newsStore.currentEventCount > 0 && (
                <div
                  class={{ tab: true, active: newsStore.tab === TabsType.Events }}
                  onClick={() => (newsStore.tab = TabsType.Events)}
                >
                  {wcShared?.translate('Evenements')}
                  {newsStore.currentEventCount > 0 && (
                    <span class="has-events">{newsStore.currentEventCount}</span>
                  )}
                </div>
              )}
              <div
                class={{ tab: true, active: newsStore.tab === TabsType.Recent }}
                onClick={() => (newsStore.tab = TabsType.Recent)}
              >
                {wcShared?.translate('Nouveautes')}
                {newsStore.unseenNewsCount > 0 && <span>{newsStore.unseenNewsCount}</span>}
              </div>
            </div>
            <div class="scroll">
              {newsStore.currentEventCount > 0 && <events-news />}
              {newsStore.tab === TabsType.Recent && <recent-news />}
            </div>
          </div>
        </Host>
      );
  }
}
